var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"countdown"},[(_vm.hms.hours)?_c('div',{staticClass:"digit"},[_vm._v(_vm._s(_vm._f("twoDigits")(_vm.hms.hours))+":")]):_vm._e(),_c('div',{staticClass:"digit"},[_vm._v(_vm._s(_vm._f("twoDigits")(_vm.hms.minutes))+":")]),_c('div',{staticClass:"digit"},[_vm._v(_vm._s(_vm._f("twoDigits")(_vm.hms.seconds)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }